import {
  type ClinicId,
  getClinicTimezone,
  toWallClockDate,
  toWallClockTime,
} from '@snootsvet/shared'

export function getAppointmentCalendarUrl(clinicId: ClinicId, startTime: string) {
  const start = new Date(startTime)
  const timeZone = getClinicTimezone(clinicId)
  const params = new URLSearchParams({
    clinic: clinicId,
    date: toWallClockDate(start, timeZone),
    time: toWallClockTime(start, timeZone),
  })
  return `/appointments?${params}`
}
